var React = require('react');

function TriangleBottom (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.262 13.369a1.5 1.5 0 01-2.524 0L2.203 6.311C1.56 5.313 2.278 4 3.465 4h9.07c1.187 0 1.904 1.313 1.262 2.31L9.262 13.37z","fill":"currentColor"}));
}

TriangleBottom.defaultProps = {"width":"9","height":"9","viewBox":"0 0 16 16"};

module.exports = TriangleBottom;

TriangleBottom.default = TriangleBottom;
